import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = window.location.hostname;

export const checkCredentials = createAsyncThunk('sendiioApp/auth/getCredentials', async () => {

	// for localhost
	let response = {
		data: {
			payload : {
				userName: 'local user',
				userToken: 'local token',
			},
			type: "sendiioApp/auth/getCredentials/fulfilled"
		}
	}

	if(API_BASE !== 'localhost'){

		response = await axios.get('https://sendiio.com/api-credentials', {

		}).catch((error) => {

			console.log('Error:', error);

		});

	}

	const data = await response.data;

	return data;

});


const initialState = {
	loading: false,
	userInfo: {}, // for user object
	userToken: null, // for storing the JWT
	error: null,
	success: false, // for monitoring the registration process.
}

const credentialsSlice = createSlice({
	name: 'credentials',
	initialState,
	reducers: {},
	extraReducers: {
		[checkCredentials.pending]: (state) => {
			state.loading = true
			state.error = null
		},
		[checkCredentials.fulfilled]: (state, { payload }) => {
			state.loading = false
			state.userInfo = payload
			state.userToken = payload.userToken
		},
		[checkCredentials.rejected]: (state, { payload }) => {
			state.loading = false
			state.error = payload
		},
	},
});

export default credentialsSlice.reducer;